module.exports = __webpack_public_path__ + "img/sequence-generator-icon.3406bda7.svg";